export const REPLY_POLICY = {
  FACEBOOK:
    '',
  TWILIO_WHATSAPP:
    '',
  WHATSAPP_CLOUD:
    '',
};

export const CHANGELOG_API_URL = '';
